import { render, staticRenderFns } from "./InviteFriendsPopup.vue?vue&type=template&id=4ce4e5b4&scoped=true"
import script from "./InviteFriendsPopup.vue?vue&type=script&lang=js"
export * from "./InviteFriendsPopup.vue?vue&type=script&lang=js"
import style0 from "./InviteFriendsPopup.vue?vue&type=style&index=0&id=4ce4e5b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce4e5b4",
  null
  
)

export default component.exports